import React from 'react';

export default class About extends React.Component {
    render() {
        return (
            <div>
                <br></br>
                <h1>ABOUT</h1>
                <p>
                    <br></br>
                    This is a website where users interested in financial securities or stocks can access its historical data.<br></br>
                    The page consists of a search tool, plot section, and a relevant news section. Users interested in news can also use the News<br></br>
                    tab to browse through most popular updates throughout their visit of our website.<br></br>
                    <br></br>
                    This website is aimed both at those who are interested in attractive companies for long-term investment and <br></br>
                    at those who want to make a short-term deal. However, this website does not verify the accuracy of the data nor<br></br>
                    does it endorse the providers of the data. Please use your own best judgement while making decisions in investments.<br></br>
                    <br></br>
                    We are working to make this accessible and free for everyone to use permanently. If you have any questions or concerns, please<br></br>
                    do not hesitate to contact us by using our Contact Form.
                </p>
                <br></br>
                <h3>Created by</h3>
                <script type="text/javascript" src="https://platform.linkedin.com/badges/js/profile.js" async></script>
                <div className="LI-profile-badge" data-version="v1" data-size="large" data-locale="en_US" data-type="vertical" data-theme="light" data-vanity="tejan-d-chinnakonda-82a99198"><a className="LI-simple-link" href='https://ca.linkedin.com/in/tejan-d-chinnakonda-82a99198?trk=profile-badge'>Tejan D. Chinnakonda</a></div>
                <br></br>
                <br></br>
            </div>
        );
    }
}
